import { computed } from 'vue';
import { useRoute } from 'vue-router';

/**
 * Provides a reactive numeric route param with a fallback on invalid values.
 */
export function useRouteNumberParam(paramName: string, fallback = -1) {
  const route = useRoute();

  return computed(() => {
    const rawParam = route.params[paramName];

    if (Array.isArray(rawParam)) {
      return fallback;
    }

    const parsedValue = parseInt(rawParam ?? '', 10);

    return Number.isNaN(parsedValue) ? fallback : parsedValue;
  });
}
